import { useEffect, useState } from 'react'
import { path } from 'ramda'
import { useDispatch, useSelector } from 'react-redux'

import useCurrentSession from '@/hooks/use-current-session'
import useSessionComplete from '@/hooks/use-session-complete'

const useListingsFavourites = () => {
  const dispatch = useDispatch()
  const hasSession = useSessionComplete()
  const session = useCurrentSession()
  const sessionLoaded = session.loaded
  const isRenter = session.user_type === 'tenant'
  const [loading, setLoading] = useState(true)
  const listings = useSelector(path(['listings', 'favourites']))
  useEffect(() => {
    const load = async () => {
      setLoading(true)
      if (!sessionLoaded) return
      if (hasSession && isRenter) {
        await dispatch.listings.getFavourites()
      }
      setLoading(false)
    }
    load()
  }, [hasSession, dispatch.listings, sessionLoaded, isRenter])
  return { listings, loading }
}

export default useListingsFavourites
